import { ILineResource } from '../../entities/farms.entities';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { toMillisecond } from '../../lib/common.helpers';
import moment from 'moment';
import { selectLang } from '../../store/ui/ui.selector';
import { translate } from '../../lib/lang.helper';
import { SelectTagsByFarmID } from '../../store/extra/extra.selector';
import LineTagModal from '../automation/LineTagModal';
import { CheckboxButton, Dropdown } from '../shared';

interface Props {
  lineData: ILineResource;
  loadLine: (i: boolean) => void;
}

const LineTagButton = ({ lineData, loadLine }: Props) => {
  const lang = useSelector(selectLang);
  const lineTags = SelectTagsByFarmID(lineData.farm_id);
  const selectedTags = lineTags?.filter(x =>
    x.tag_lines.some(y => y.line_id === lineData.id),
  );

  const [visible, setVisible] = useState(false);

  return !!lineTags && lineTags.length > 0 ? (
    <>
      {!selectedTags || selectedTags.length <= 0 ? (
        <button className='line-tag-btn' onClick={() => setVisible(true)}>
          {translate(lang, 'No tagged')}
        </button>
      ) : (
        selectedTags.map(x => (
          <button
            key={x.id}
            className='line-tag-btn'
            onClick={() => setVisible(true)}
          >
            <div key={x.id} style={{ margin: '2px 10px' }}>
              <div style={{ fontSize: '15px', fontWeight: '600' }}>
                {x.name}
              </div>
              <div style={{ fontSize: '12px', fontWeight: '500' }}>
                {translate(
                  lang,
                  'tagged %s days ago',
                  moment().diff(
                    toMillisecond(
                      x.tag_lines.find(y => y.line_id === lineData.id)
                        ?.created_at,
                    ),
                    'days',
                  ),
                )}
              </div>
            </div>
          </button>
        ))
      )}
      {visible && (
        <LineTagModal
          visible={visible}
          onClose={() => setVisible(false)}
          lineData={lineData}
          onChange={async () => await loadLine(true)}
        />
      )}
    </>
  ) : (
    <></>
  );
};

export default LineTagButton;

interface TagSelectProps {
  lineData: ILineResource;
  tagIDs?: number[] | null;
  onChange: (ids: number[] | null) => void;
  className?: string;
}

export const TaggingManageForm = ({
  lineData,
  tagIDs,
  onChange,
  className,
}: TagSelectProps) => {
  const lang = useSelector(selectLang);
  const lineTags = SelectTagsByFarmID(lineData.farm_id);
  const selectedTags = lineTags?.filter(x =>
    x.tag_lines.some(y => y.line_id === lineData.id),
  );

  const toggleManage = (c: boolean) => {
    if (c) {
      onChange(selectedTags?.map(x => x.id) ?? []);
    } else {
      onChange(null);
    }
  };
  const selectTags = (vals: string[]) => {
    onChange(vals.map(x => Number(x)));
  };

  return (
    <div className={className}>
      <div className='mb-17'>
        <CheckboxButton
          label={translate(lang, 'Manage line tagging')}
          checked={tagIDs !== null && tagIDs !== undefined}
          onChange={e => toggleManage(e.target.checked)}
        />
      </div>
      {tagIDs !== undefined && tagIDs !== null && (
        <div className='mb-17'>
          <Dropdown
            label={translate(lang, 'Select tags')}
            mode='multiple'
            placeholder={translate(
              lang,
              'Select tagged names or deselect untagged names',
            )}
            options={
              lineTags?.map(x => ({
                id: x.id.toString(),
                value: x.id.toString(),
                label: x.name,
              })) ?? []
            }
            value={tagIDs.map(i => i.toString()) as any}
            onChange={(vals: any) => selectTags(vals)}
          />
        </div>
      )}
    </div>
  );
};
